import { render, staticRenderFns } from "./jy-signReceipt.vue?vue&type=template&id=6013e5e2&scoped=true&"
import script from "./jy-signReceipt.vue?vue&type=script&lang=js&"
export * from "./jy-signReceipt.vue?vue&type=script&lang=js&"
import style0 from "./jy-signReceipt.vue?vue&type=style&index=0&id=6013e5e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013e5e2",
  null
  
)

export default component.exports